import * as React from "react";
import Stack from "@mui/material/Stack";
import Chip from "@mui/material/Chip";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import Checkbox from "@mui/material/Checkbox";
import { useState, useEffect } from "react";
import axios from "../utils/fvAxios";
import apiinfo from "../utils/base-uri.json";
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export default function MultiSelectAutoComplete({
  placeholder,
  onSelectedChange,
  selectedIds,
  pqId,
}) {
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [options, setOptions] = useState([]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (selectedIds.length != selectedOptions?.length) {
      // check if current selected and parent's current selected is not same
      setSelectedOptions(selectedIds);
    }
  }, [selectedIds]);

  useEffect(() => {
    let active = true;

    const fetchData = async () => {
      // if (inputValue === "") {
      //   setOptions(selectedOptions ? [] : []);
      //   return;
      // }

      try {
        const response = await axios.get(
          `${apiinfo.Clients.GetFilteredPQClientsInSite}pqId=${pqId}&searchString=${inputValue}`
        );

        const newOptions = response?.data?.data?.item2?.unlockedClients?.map(
          (x) => ({
            text: x?.text,
            value: x?.value,
          })
        );

        if (active) {
          let updatedOptions = [];

          if (selectedOptions) {
            // Filter out duplicates from newOptions before adding them to selectedOptions
            updatedOptions = newOptions?.filter((newOption) => {
              return !selectedOptions?.some(
                (selectedOption) => selectedOption.value === newOption.value
              );
            });

            setOptions([...updatedOptions, ...selectedOptions]);
          } else {
            setOptions(newOptions);
          }
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();

    return () => {
      active = false;
    };
  }, [inputValue]);

  // const LoadAPiOptions = async (_inputValue) => {
  //   if (!_inputValue) return [];
  //   let options = [];
  //   axios
  //     .get(
  //       `${apiinfo.Clients.GetFilteredPQClientsInSite}pqId=${pqId}&searchString=${_inputValue}`
  //     )
  //     .then((res) => {
  //       options = res.data?.data?.item2?.unlockedClients?.map((x) => ({
  //         text: x.text,
  //         value: x.value,
  //       }));
  //       return options;
  //     })
  //     .catch((err) => {
  //       console.error(err);
  //     });

  //   return [];
  // };

  const onOptionChange = (e, selectedValues, changeReason) => {
    onSelectedChange(selectedValues);
    const isSelected = changeReason == "selectOption";
    if (isSelected) {
      setSelectedOptions(selectedValues);
      setOpen(false);
      setOptions([]);
    } else {
      setOptions([]);
      setSelectedOptions(selectedValues);
    }
  };

  useEffect(() => {
    if (!open) setInputValue(null);
    setOptions([]);
    //}
  }, [open]);

  return (
    <Stack sx={{ maxWidth: 400 }}>
      <Autocomplete
        multiple
        size={"small"}
        open={open}
        onOpen={() => {
          setOpen(true);
        }}
        onClose={() => {
          setOpen(false);
        }}
        //filterSelectedOptions={true}
        id="checkboxes-tags-demo"
        options={options}
        disableCloseOnSelect
        value={selectedOptions}
        getOptionLabel={(option) => option.text}
        filterOptions={(options, params) => {
          return options;
        }}
        freeSolo
        renderOption={(props, option, { selected }) => (
          <li {...props}>
            <Checkbox
              icon={icon}
              checkedIcon={checkedIcon}
              style={{ marginRight: 8 }}
              checked={selected}
            />
            {option.text}
          </li>
        )}
        onChange={onOptionChange}
        // style={{ width: 300 }}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={placeholder}
            onChange={(event) => {
              setInputValue(event?.target?.value);
            }}
          />
        )}
      />
    </Stack>
  );
}
